import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BarGraphHorizontalIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M3 2a1 1 0 01.993.883L4 3v17h17a1 1 0 01.117 1.993L21 22H3a1 1 0 01-.993-.883L2 21V3a1 1 0 011-1zm12 14a1 1 0 01.117 1.993L15 18H6a1 1 0 01-.117-1.993L6 16h9zm4-4a1 1 0 01.117 1.993L19 14H6a1 1 0 01-.117-1.993L6 12h13zM6 8h5a1 1 0 01.117 1.993L11 10H6a1 1 0 01-.117-1.993L6 8h5zm9-4a1 1 0 010 2H6a1 1 0 110-2z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
BarGraphHorizontalIcon.isCarinaIcon = true;
export default BarGraphHorizontalIcon;
